export default __webpack_public_path__ + "static/media/person_1.e48c2dee.png";